import { LinkToProcoreEntity } from "./components/link-to-procore-entity/link-to-procore-entity";
import { GanttContainer } from "./components/gantt/gantt-container";
import { LaborPlansContainer } from "./components/labor-plans/labor-plans-container";
import { TimeOffListContainer } from "./components/time-off-list/time-off-list-container";
import { IntegrationSettingsContainer } from "./components/settings/integration-settings/integration-settings-container";
import { ProjectListContainer } from "./components/project-list/project-list-container";
import { PeopleListContainer } from "./components/people-list/people-list-container";
import { NotFound } from "./components/not-found";
import { ProjectQrProfile } from "./components/qr-profiles/project-qr-profile";
import { AssignmentListContainer } from "./components/assignment-list/assignment-list-container";
import BoardsContainer from "./components/boards";
import { HomeContainer } from "./components/home/home-container";
import { ShiftProjectModal } from "./components/modals/shift-project/shift-project-modal";
import { RequestListContainer } from "./components/request-list/request-list-container";
import { Totals } from "./components/totals/Totals";
import { CommunicationsContainer } from "./components/communications/communications-container";

const components = {
   LinkToProcoreEntity,
   NotFound,
   GanttContainer,
   LaborPlansContainer,
   TimeOffListContainer,
   IntegrationSettingsContainer,
   ProjectListContainer,
   PeopleListContainer,
   AssignmentListContainer,
   ProjectQrProfile,
   BoardsContainer,
   HomeContainer,
   ShiftProjectModal,
   RequestListContainer,
   Totals,
   CommunicationsContainer,
} as const;

export default components;
